import selectProjectIcon from "../../assets/home-page/select-project.svg";
import uploadIcon from "../../assets/home-page/upload.svg";
import trackIcon from "../../assets/home-page/track.svg";
import downloadIcon from "../../assets/home-page/download.svg";

const STEPS = [
  { icon: selectProjectIcon, label: "Select a project" },
  { icon: uploadIcon, label: "Upload IFC Model" },
  { icon: trackIcon, label: "Track Audit process" },
  { icon: downloadIcon, label: "Download report and NCS" },
];

interface HowItWorksProps {
  title?: string;
  className?: string;
}

const HowItWorks = ({
  title = "How it works",
  className = "",
}: HowItWorksProps) => {
  return (
    <div className={`how-it-works mt-8 md:mt-12 ${className}`}>
      <h2 className="text-2xl sm:text-3xl font-semibold text-[#E761A0] mb-6 md:mb-10">
        {title}
      </h2>
      <div className="relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-4 xl:gap-6 max-w-[1155px] items-start">
          {STEPS.map((step, i) => (
            <div
              key={i}
              className={`relative z-10 flex flex-col w-full items-center max-w-full sm:max-w-[200px] lg:max-w-[215px] mx-auto lg:mx-0 ${i === 0 ? "lg:items-start lg:max-w-[140px] text-left justify-start]" : "lg:items-center"}`}
            >
              <div
                className={`flex flex-col w-full items-center text-center max-w-[215px] mx-auto lg:mx-0 ${i === 0 ? "lg:items-center lg:text-left justify-start" : "lg:items-center lg:text-center"}`}
              >
                <div className="mb-3 md:mb-4 w-full h-[80px] sm:h-[100px] lg:h-[125px] flex justify-center items-center after-line 2xl:max-w-[215px] max-w-[83px]">
                  <img
                    src={step.icon || undefined}
                    alt=""
                    className="object-contain max-h-[70px] sm:max-h-[90px] lg:max-h-[110px] w-auto"
                    aria-hidden
                  />
                </div>
                <p className="text-white text-base text-[14px] lg:text-[16px] xl:text-[18px] font-weight-300 text-center">
                  {step.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
